import { useEffect, useRef, useState } from "react";
import { AssemblyItemsViewModel } from "../../../viewmodels/setup/assemblyItems/AssemblyItemsViewModel";
import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";
import { withRouter } from "../../../shared/utility";
import SlideOver from "../../../components/slideOver/SlideOver";
import {
  SetupActions,
  SetupPage,
  SetupTable,
  SetupTd,
} from "../../../components/setup/SetupPage";
import AuditActionLink from "../../../components/audit/AuditActionLink";
import { auditHistoriesSetupAction } from "../../../components/audit/auditEntityConfig";

function AssemblyItems(props) {
  const { addSnackbar, logout } = props;
  const {
    deleteAssemblyItem,
    openAddAssemblyItemSlideOver,
    getAllergensForDropdown,
    getAssemblyItems,
    getCertifiedByOptionsForDropdown,
    getClaimsForDropdown,
    getManufacturersForDropdown,
    getMyIngredientsOptionsForDropdown,
    getPreservativesForDropdown,
    getProductTypes,
    getTaxRatesForDropdown,
    loading,
    assemblyItems,
    setSlideOver,
    slideOver,
    fetchAssemblyItemDetails,
    getUnitOfMeasuresForDropdown,
    getCountryOptionsForDropdown,
  } = AssemblyItemsViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    getAllergensForDropdown();
    getCountryOptionsForDropdown();
    getAssemblyItems(null, currentPage);
    getCertifiedByOptionsForDropdown();
    getClaimsForDropdown();
    getManufacturersForDropdown();
    getPreservativesForDropdown();
    getProductTypes();
    getUnitOfMeasuresForDropdown();
    getMyIngredientsOptionsForDropdown();
    getTaxRatesForDropdown();
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);
  const searchRef = useRef();

  const handleSearch = () => {
    getAssemblyItems(searchRef.current.value, currentPage);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getAssemblyItems(searchRef.current.value, currentPage);
  };

  return (
    <div>
      <SetupPage
        title="Supplier Items"
        description="Manage supplier item records, manufacturer PLUs, and the item details used in receiving and traceability."
        searchPlaceholder="Search by supplier item"
        searchRef={searchRef}
        onSearch={handleSearch}
        actions={[
          { label: "Add Item", onClick: openAddAssemblyItemSlideOver },
          auditHistoriesSetupAction("assembly-item"),
        ]}
        loading={loading}
        tableColumns={["Item", "Manufacturer", "Manufacturer PLU"]}
        totalRecords={assemblyItems.total}
        first={first}
        rows={rows}
        onPageChange={handlePagination}
      >
        <SetupTable
          columns={["Item", "Manufacturer", "Manufacturer PLU"]}
          emptyText="No supplier items found."
        >
          {assemblyItems.data?.map((assemblyItem, index) => (
            <tr
              key={assemblyItem.id}
              className="transition hover:bg-[#F6F8FB]/80"
            >
              <SetupTd>
                <div>{assemblyItem.product_name}</div>
                <div className="mt-1 text-xs font-normal text-[#64748B]">
                  {assemblyItem.product_code || "No product code"}
                </div>
              </SetupTd>
              <SetupTd muted={true}>{assemblyItem.manufacturer}</SetupTd>
              <SetupTd muted={true}>{assemblyItem.manufacturer_plu}</SetupTd>
              <SetupActions>
                <button
                  type="button"
                  onClick={() => fetchAssemblyItemDetails(assemblyItem, index)}
                  className="inline-flex min-w-[68px] justify-center rounded-lg border border-[#E2E8F0] bg-white px-3 py-1.5 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB]"
                >
                  Edit
                </button>
                <AuditActionLink
                  slug="assembly-item"
                  id={assemblyItem.id}
                  name={
                    assemblyItem.product_name ||
                    assemblyItem.product_code ||
                    ""
                  }
                  className="ml-2"
                />
                <button
                  type="button"
                  onClick={() => deleteAssemblyItem(assemblyItem.id, index)}
                  className="ml-2 inline-flex min-w-[68px] justify-center rounded-lg border border-[#FECACA] bg-white px-3 py-1.5 text-sm font-semibold text-[#DC2626] shadow-sm transition hover:border-[#FCA5A5] hover:bg-[#FEF2F2]"
                >
                  Delete
                </button>
              </SetupActions>
            </tr>
          ))}
        </SetupTable>
      </SetupPage>
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AssemblyItems),
);
